import {Link, useNavigate} from "react-router-dom";
import ImgLogo from '../../images/BRW-logo.webp';
import React from "react";
import {useAuth} from "../../context/AuthContext";

function AdminNavbar() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await logout();
      navigate('/login');
    } catch {
      console.error('Failed to log out');
    }
  }
  
  return (
    <nav
      className="navbar"
      style={{
        background: "white",
      }}
    >
      <div className="navbar-container z-[999]">
        <div className={"flex flex-1 flex-col sm:flex-row gap-4 text-[#081542]"}>
          <Link to={"/admin/projects"} style={{ textDecoration: "underline"}} className={"text-base sm:text-xl transition duration-300 ease-in-out hover:opacity-60"}>Projects</Link>
          <Link to={"/admin/add-project"} style={{ textDecoration: "underline"}} className={"underline text-base sm:text-xl transition duration-300 ease-in-out hover:opacity-60"}>Add Project</Link>
        </div>
        <div className={"flex justify-center flex-1"}>
          <Link to="/" className="navbar-logo">
            <img
              className="brw-logo"
              src={ImgLogo}
              alt="BRW construction logo"
            />
          </Link>
        </div>
        <div className={"flex justify-end flex-1"}>
          <button
            onClick={handleLogout}
            className="bg-gray-200 text-[#081542] hover:bg-gray-300 text-base sm:text-xl py-2 px-4 rounded"
          >
            Log Out
          </button>
        </div>
      </div>
    </nav>
  );
}

export default AdminNavbar;